export default "__VITE_ASSET__CDANuE_C__"